import { Stack, Typography } from "@mui/material";
import { InitialNameAvatar } from "../../../components/images/initial-name-avatar";
import { SimpleTable } from "../../../components/mui/table";
import { ENUM_CURRENCY, RENDERER_TYPES } from "../../../enums";
import { convertToFullName, numberFormat } from "../../../services/utils";
import { MenuActionButton, UnarchiveActionButton } from "../../../components/buttons";

function ClientListTable({
  list,
  columns,
  handlePageFilters,
  toggleMenuOptions,
  appliedFilters,
  onShowViewCountDetailsClick,
  isDeleted = false,
  onUnarchiveClick,
}: any) {
  const { selectedPage, selectedPageSize } = appliedFilters;

  const handleTDRenderer = (row, column) => {
    switch (column.rendererType) {
      case RENDERER_TYPES.FULL_NAME_WITH_AVATAR:
        return (
          <InitialNameAvatar
            text={convertToFullName(row.firstName, row.lastName)}
            name={row.firstName}
          />
        );
      case RENDERER_TYPES.AMOUNT:
        return numberFormat(row[column.field], ENUM_CURRENCY.USD);
      case RENDERER_TYPES.ACTION:
        switch (column.field) {
          case "viewCount":
            if (!row?.[column?.field]) return "-";

            return (
              <Typography
                component={"a"}
                href="#"
                onClick={(e) => {
                  e?.preventDefault();
                  onShowViewCountDetailsClick(row);
                }}
              >
                {numberFormat(row?.[column?.field])}
              </Typography>
            );
          default:
            if (isDeleted) {
              return (
                <Stack gap={1} direction="row" justifyContent="flex-end">
                  <UnarchiveActionButton onClick={() => onUnarchiveClick?.(row.id)} />
                </Stack>
              );
            }
            return (
              <MenuActionButton
                onClick={(e) => toggleMenuOptions(e, row.id, row)}
                key={row.id}
              />
            );
        }

      default:
        break;
    }
  };

  return (
    <SimpleTable
      tdRenderer={handleTDRenderer}
      rows={list?.data}
      fetching={list?.loading}
      columns={columns}
      total={list?.total}
      onPageSettingsChange={handlePageFilters}
      selectedPage={selectedPage}
      selectedPageSize={selectedPageSize}
    ></SimpleTable>
  );
}

export { ClientListTable };
